import { Trans, useLingui } from '@lingui/react/macro';

import { FilterCheckboxItem } from '@/design_system/Filters/FiltersMenu/FilterCheckboxItem';
import {
  FilterItemNoResults,
  FiltersMenu,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import IconValidation from '@/icons/Validation.svg';
import { ARTICLE_WARRANTY_TYPES } from '@/models/article';

import { useFilters } from '../FiltersState';
import { useWarrantyTypeOptions } from '../utils';

export const FiltersWarrantyType = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    warrantyTypes: { warrantyTypes, setWarrantyTypes },
  } = useFilters();

  const warrantyTypeOptions = useWarrantyTypeOptions();

  const options =
    warrantyTypeOptions.length > 0 ? (
      warrantyTypeOptions.map(({ id, label }) => (
        <FilterCheckboxItem
          key={id}
          checked={warrantyTypes.includes(id)}
          onChange={(checked) => {
            if (checked) {
              setWarrantyTypes([...warrantyTypes, id]);
            } else {
              setWarrantyTypes(warrantyTypes.filter((warrantyType) => warrantyType !== id));
            }
          }}
        >
          {i18n._(label)}
        </FilterCheckboxItem>
      ))
    ) : (
      <FilterItemNoResults />
    );

  if (tag) {
    if (warrantyTypes.length === 0) {
      return null;
    }

    const nbWarrantyTypes = warrantyTypes.length;

    return (
      <FiltersMenu
        button={
          <FilterTag
            label={t({ id: 'requests.filters.warranty-type.label', message: 'Warranty type' })}
            value={
              warrantyTypes.length === 1 ? (
                i18n._(
                  ARTICLE_WARRANTY_TYPES.find(
                    (warrantyType) => warrantyType.id === warrantyTypes[0]
                  )!.label
                )
              ) : (
                <Trans id="requests.filters.warranty-type.multiple">
                  {nbWarrantyTypes} warranty types
                </Trans>
              )
            }
            tooltip={
              warrantyTypes.length > 1
                ? warrantyTypes
                    .map((warrantyType) =>
                      i18n._(ARTICLE_WARRANTY_TYPES.find((awt) => awt.id === warrantyType)!.label)
                    )
                    .join(', ')
                : undefined
            }
            onClear={() => setWarrantyTypes([])}
          />
        }
      >
        {options}
      </FiltersMenu>
    );
  }

  return (
    <FiltersSubMenu
      icon={<IconValidation />}
      label={t({ id: 'requests.filters.warranty-type.label', message: 'Warranty type' })}
    >
      {options}
    </FiltersSubMenu>
  );
};
